import type React from 'react';

import type { UFOExperience } from '@atlassian/ufo';
import { useUFOComponentExperience } from '@atlassian/ufo';

export interface UFOProductExperienceProps {
    ufoExperience: UFOExperience;
}

export const ProductExperienceStart: React.FunctionComponent<UFOProductExperienceProps> = (props) => {
    const { ufoExperience } = props;
    useUFOComponentExperience(ufoExperience);
    return null;
};

export const externalLinksProductExperienceId = 'service-management.help-center.external-resources';
export const yourApprovalExperienceId = 'service-management.help-center.your-approval';
export const publishLayoutExperienceId = 'service-management.help-center.publish.layout';
export const topicsReorderExperienceId = 'service-management.help-center.topics.reorder';
export const helpCenterTopicsProductExperienceId = 'service-management.help-center.topics';
export const helpCenterTopicEditExperienceId = 'service-management.help-center.topic.edit';
export const helpCenterTopicViewExperienceId = 'service-management.help-center.topic.view';

export const viewHomepageExperienceId = 'service-management.help-center.advanced.homepage.view';
export const editHomepageExperienceId = 'service-management.help-center.advanced.homepage.edit';

export const viewHelpDeskExperienceId = 'service-management.help-center.help-desk.view';

export const editHelpDeskExperienceId = 'service-management.help-center.help-desk.edit';
export const deleteHelpDeskExperienceId = 'service-management.help-center.help-desk.delete';

export const viewUnifiedHelpHomeExperienceId = 'service-management.help-center.unified-help.home';
export const viewUnifiedHelpChatsExperienceId = 'service-management.help-center.unified-help.chats';

export const viewKnowledgeResourceExperienceId = 'service-management.help-center.knowledge-resource.view';
export const viewExternalLinksExperienceId = 'service-management.help-center.external-links.view';
export const addProviderConnectionExperienceId = 'service-management.help-center.provider-connections.add';
export const editProviderConnectionExperienceId = 'service-management.help-center.provider-connections.edit';
export const deleteProviderConnectionExperienceId = 'service-management.help-center.provider-connections.delete';
export const addExternalLinksExperienceId = 'service-management.help-center.external-links.add';
export const editExternalLinksExperienceId = 'service-management.help-center.external-links.edit';
export const deleteExternalLinksExperienceId = 'service-management.help-center.external-links.delete';

export const searchExperienceId = 'service-management.help-center.search';
export const appsAuthenticationExperienceId = 'service-management.help-center.connected-apps.authenticate';

export const requestServiceDeskFromPortalExperienceId = 'service-management.help-center.request-service-desk-cta';

export const helpCenterReportingExperienceId = 'service-management.help-center.help-center-reporting';
